import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'reflect-metadata';

import React from 'react';
import ReactDOM from 'react-dom';

import BasketCheckoutModule from './BasketCheckoutModule';

if (process.env.REACT_APP_MODE === 'APP') {
    ReactDOM.render(
        <BasketCheckoutModule basePath='/basket' />,
        document.getElementById('basket-checkout-module-root')
    );
}

export { BasketCheckoutModule };